import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IApiTokensQueryParams, IApiTokenDto, IQueryResult } from 'gen/ApiClient';

export const ApiTokensQueryContext = React.createContext<IQueryContext<IQueryResult<IApiTokenDto>, IApiTokensQueryParams>>(undefined as any);
